import { Dropdown } from '@ui/atoms/dropdown'
import clsx from 'clsx'
import React, { useCallback, useState } from 'react'
import { Bar } from 'react-chartjs-2'

import { type DataType } from '../graph-types'
import { mergeOptions } from '../mapper'

const BUSY_PERIODS_GRAPH_COLORS = ['#88C648', '#EF8933', '#E30404']

type BusyPeriodsGraphPropsType = {
  options?: Record<string, unknown>
  data: DataType
  handleChange?: (n: number) => void
}
export const BusyPeriodsGraph: React.FC<BusyPeriodsGraphPropsType> = ({
  data,
  options,
  handleChange = () => {
    console.log('missing handlechange function')
  },
}) => {
  const [currentSelected, setCurrentSelected] = useState(0)

  const overideOptions = {
    ...options,
    responsive: true,
    maintainAspectRatio: false, // change to get small/tall graph
    plugins: {
      ...options.plugins,
      legend: { ...options.plugins.legend, position: 'top', display: false },
      tooltip: { enabled: false },
      scales: {
        xAxis: [
          {
            gridLines: {
              display: false,
            },
          },
        ],
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 14,
            family: 'Gotham',
            weight: 'bold',
          },
          color: 'black',
          callback: function (val, index) {
            // eslint-disable-next-line react/no-this-in-sfc
            return index % 3 === 0 ? this.getLabelForValue(val) : ''
          },
        },
      },
      y: {
        display: false,
        grid: {
          display: false,
        },
      },
    },
  }

  const handleOptionChange = useCallback((e) => {
    const newValue = parseInt(e.target.value)
    if (!newValue && newValue !== 0) return
    setCurrentSelected(newValue)
    handleChange(newValue)
  }, [])

  const d: DataType = JSON.parse(JSON.stringify(data))
  d.labels.forEach((_l, i) => {
    d.datasets.forEach((_d, j) => {
      d.datasets[j].backgroundColor[i] =
        BUSY_PERIODS_GRAPH_COLORS[d.datasets[j].data[i] - 1]
      d.datasets[j].borderRadius = 5
    })
  })

  const hasMultipleGraphs = d?.datasets?.length > 1
  return (
    <>
      {hasMultipleGraphs && (
        <Dropdown
          className="mb-10 mt-2 w-full min-w-0 px-2 tablet:max-w-[300px] laptop:my-2 laptop:ml-[6px] laptop:self-start"
          emptyOption={false}
          label="Horaires d'affluences"
          value={currentSelected.toString()}
          onChange={handleOptionChange}
        >
          {d.datasets.map((li, index) => (
            <option key={index} label={li.label} value={index.toString()} />
          ))}
        </Dropdown>
      )}
      {d.datasets.map((dataset, i) => (
        <div
          key={i}
          className={clsx(
            'min-h-[300px]',
            'w-full',
            i === currentSelected ? 'block' : 'hidden'
          )}
        >
          <Bar
            data={{ ...d, datasets: [dataset] }}
            options={mergeOptions(options, overideOptions)}
            redraw={true}
          />
        </div>
      ))}
    </>
  )
}
